export default __webpack_public_path__ + "static/experienceImg4-026cddfdc712798dea77aef6cec87abb.webp";